var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('v-sparkline',{attrs:{"value":_vm.value,"gradient":_vm.gradient,"smooth":10,"padding":1,"line-width":2,"stroke-linecap":10,"gradient-direction":"top","type":"trend","auto-draw":"","auto-draw-duration":_vm.cycle,"height":24}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }